export default {
  create: {
    title: 'Agregar',
    subtitle: 'Criptograma',
  },
  edit: {
    title: 'Editar',
    subtitle: 'Juego',
    button: {
      add: 'Nuevo juego',
    },
  },
  list: {
    title: 'Criptogramas',
    subtitle: 'Lista',
    add: 'Nuevo juego',
  },
  card: {
    title: 'Generador de criptogramas',
    actions: 'Acciones',
  },
  table: {
    title: 'Juegos activos',
    searchPlaceholder: 'Buscar por algo...',
  },
  form: {
    name: {
      label: 'Nombre:',
      invalid: 'El nombre es obligatorio',
    },
    font: {
      label: 'Seleccionar fuente:',
    },
    theme: {
      label: 'Estilo del juego:',
      default: 'Tema predeterminado',
      radius: 'Redondeado',
      molotov: 'Molotov',
    },
    level: {
      label: 'Nivel:',
    },
    columns: 'Columnas:',
    rows: 'Filas:',
    hint: 'Doble clic para cambiar el color de fondo.',
  },
  button: {
    fillWords: 'Completar palabras',
    clearGame: 'Limpiar juego',
    printGame: 'Imprimir juego',
    printAnswers: 'Imprimir respuestas',
    addQuestion: 'Agregar nueva pregunta',
    editQuestion: 'Editar pregunta',
  },
  cell: {
    fillWord: 'Completar el resto de la palabra aleatoriamente',
    clearLine: 'Limpiar fila',
  },
  sidebar: {
    sendHint: 'Debe guardar antes de enviar.',
  },
  alert: {
    wordCompleted: '¡Palabra completada con éxito!',
    cryptogramCleared: '¡Criptograma limpio!',
    wordNotFound: '¡Ninguna palabra encontrada!',
    questionAdded: '¡Pregunta agregada con éxito!',
    questionDeleted: '¡Pregunta eliminada con éxito!',
    questionEdited: '¡Pregunta editada con éxito!',
    questionSaveError: 'Error al guardar la pregunta.',
    questionDeleteError: 'Error al eliminar la pregunta.',
    sendSuccess: 'Enviado con éxito',
    sendError: 'Error al enviar. Inténtelo de nuevo.',
  },
};
